import type { UseCase } from '@/core/shared'
import type { AuthRepository } from '../domain'

export const doPasswordReset: UseCase<AuthRepository, 'passwordReset'> = repository => {
  return async (passwordReset) => {
    await repository.passwordReset(passwordReset)
  }
}
